import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("div", { class: "flex items-center gap-2 mb-2" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "w-8 h-8 bg-accent-100 rounded-lg flex items-center justify-center flex-shrink-0" }, [
    /*#__PURE__*/_createElementVNode("svg", {
      class: "w-5 h-5 text-accent-700",
      fill: "none",
      stroke: "currentColor",
      viewBox: "0 0 24 24"
    }, [
      /*#__PURE__*/_createElementVNode("path", {
        "stroke-linecap": "round",
        "stroke-linejoin": "round",
        "stroke-width": "2",
        d: "M8 7V3m8 4V3m-9 8h10M5 21h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v12a2 2 0 002 2z"
      })
    ])
  ]),
  /*#__PURE__*/_createElementVNode("span", { class: "text-sm font-medium text-primary-500 truncate" }, "Events")
], -1)
const _hoisted_2 = { class: "flex items-baseline gap-1" }
const _hoisted_3 = { class: "text-2xl md:text-3xl font-bold text-primary-800" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("span", { class: "text-xs md:text-sm text-primary-500" }, "upcoming", -1)
const _hoisted_5 = /*#__PURE__*/_createElementVNode("p", { class: "text-xs text-accent-600 mt-1 truncate" }, "View calendar →", -1)


export default /*#__PURE__*/_defineComponent({
  props: {
    count: null
  },
  setup(__props: any) {



return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createBlock(_component_router_link, {
    to: "/events",
    class: "block bg-white border border-primary-200 rounded-xl p-3 md:p-4 shadow-soft hover:shadow-card hover:-translate-y-0.5 transition-all duration-200 cursor-pointer overflow-hidden min-w-0"
  }, {
    default: _withCtx(() => [
      _hoisted_1,
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("span", _hoisted_3, _toDisplayString(__props.count), 1),
        _hoisted_4
      ]),
      _hoisted_5
    ]),
    _: 1
  }))
}
}

})